import numeral from 'numeral'
import { ComponentType } from 'react'

interface Props {
  property: any
  onClick: () => void
}

export const Bubble: ComponentType<Props> = ({ property, onClick }) => (
  <div
    className="rounded-md overflow-hidden shadow bg-white d-flex align-items-center font-family-cabin"
    onClick={onClick}
  >
    {property.role.includes('sale') && <div className="p-10 bg-primary text-white font-weight-bold">V</div>}
    {property.role.includes('rent') && <div className="p-10 bg-success text-white font-weight-bold">R</div>}
    <h6 className="mb-0 px-10 font-size-14 font-weight-bold">
      {property.sale?.price ? (
        <>
          {numeral(property.sale.price).format('$0,0')} {property.currency}
        </>
      ) : property.rent?.monthPrice ? (
        <>
          {numeral(property.rent.monthPrice).format('$0,0')} {property.currency}/mes
        </>
      ) : null}
    </h6>
  </div>
)
